<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="loading" />
					<div v-if="!loading" class="navbar-text nav-title flex" id="pageTitle">
						{{ full_name }}'s Profile
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="!loading">
						<div class="d-sm-flex b-t h-100">
							<div class="w w-auto-xs light bg b-r">
								<div class="py-3">
									<div class="nav-active-border left b-primary">
										<ul class="nav flex-column nav-sm">
											<li class="nav-item">
												<a
													class="nav-link"
													:class="{ active: tab == 1, show: tab == 1 }"
													data-toggle="tab"
													data-target="#tab-1"
												>
													Personal Details
													<i
														class="valid-hint text fa fa-angle-left"
														:class="{ invalid: !valid.group('details') }"
													></i>
												</a>
											</li>
											<!-- <li class="nav-item">
												<a class="nav-link" :class="{active: tab == 2, show: tab == 2}" data-toggle="tab" data-target="#tab-2">
													Settings
													<i class="valid-hint text fa fa-angle-left" :class="{invalid: !valid.group('settings')}"></i>
												</a>
											</li>-->
										</ul>
									</div>
								</div>
							</div>

							<edit-pane :cancel="loadData" :save="saveProfile" :dirty="dirty" :valid="valid">
								<div class="tab-content">
									<!-- User -->
									<div id="tab-1" class="tab-pane" :class="{ active: tab == 1, show: tab == 1 }">
										<div class="p-4 b-b _600 nav-title">Personal Details</div>
										<div class="col-md-10 col-12">
											<div class="row m-0 pt-4">
												<div class="col-sm-6 col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>First Name</label>
														<input
															type="text"
															class="form-control"
															v-model="profile.first_name"
														/>
													</div>
												</div>
												<div class="col-sm-6 col-12">
													<div class="form-group" :class="{ invalid: !valid.field('name') }">
														<label>Last Name</label>
														<input
															type="text"
															class="form-control"
															v-model="profile.last_name"
														/>
													</div>
												</div>
											</div>
											<div class="row m-0">
												<div v-if="profile.scorer_id" class="col-12 col-sm-6 form-group">
													<label>Scorer ID</label>
													<input
														type="text"
														class="form-control"
														v-model="profile.scorer_id"
														readonly
													/>
												</div>
												<div
													class="col-12 col-sm-6 form-group"
													:class="{ invalid: !valid.field('email') }"
												>
													<label>Email</label>
													<input
														type="text"
														class="form-control"
														v-model.trim="profile.email"
														label="name"
													/>
												</div>
											</div>
											<div class="row m-0">
												<div class="form-group col-sm-6 col-12">
													<label>Role</label>
													<v-select
														:options="roles"
														v-model="sRole"
														label="name"
														disabled
													></v-select>
												</div>
												<div class="form-group col-sm-6 col-12">
													<label>District</label>
													<v-select
														:options="districts"
														v-model="sDistrict"
														label="name"
														disabled
													></v-select>
												</div>
											</div>
											<div class="row m-0">
												<div class="form-group col-sm-6 col-12">
													<label>Preferred Content Areas</label>
													<v-select
														:options="areas"
														v-model="sAreas"
														multiple
														label="name"
													></v-select>
												</div>
												<div class="form-group col-sm-6 col-12">
													<label>Preferred Grades</label>
													<v-select
														:options="grades"
														v-model="sGrades"
														multiple
														label="name"
													></v-select>
												</div>
											</div>
											<div class="row m-0">
												<div
													class="col-12 col-sm-6 form-group"
													:class="{ invalid: !valid.field('password') }"
												>
													<label>New Password</label>
													<input
														type="password"
														class="form-control"
														v-model.trim="profile.password"
													/>
												</div>
												<div
													class="col-12 col-sm-6 form-group d-flex flex-column justify-content-end"
												>
													<div
														class="mt-1 mb-0 text-xs text-muted"
														v-for="error in valid.errors('password')"
														:key="error"
														style="min-height: 28px;"
													>
														{{ error }}
													</div>
												</div>
											</div>
											<div class="row m-0" :class="{ invalid: !valid.field('passwordMatch') }">
												<div class="col-12 col-sm-6 form-group">
													<label>Confirm Password</label>
													<input
														type="password"
														class="form-control"
														v-model.trim="password2"
													/>
												</div>
												<div
													class="col-12 col-sm-6 form-group d-flex flex-column justify-content-end"
												>
													<div
														class="mt-1 mb-0 text-xs text-muted"
														v-for="error in valid.errors('passwordMatch')"
														:key="error"
														style="min-height: 28px;"
													>
														{{ error }}
													</div>
												</div>
											</div>
											<div class="row m-0">
												<div class="col-12 col-sm-6 form-group">
													<div class="checkbox mr-3">
														<label
															class="md-check"
															v-tippy="{ theme: 'popover', placement: 'bottom-start' }"
															title="Prevents receiving email notifications on alert flags or when new responses are loaded.</br>Password reset emails will still function."
														>
															<input v-model="profile.suppress_emails" type="checkbox" />
															<i class="theme-accent"></i>
															Suppress Email Notifications
														</label>
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- Settings -->
									<div id="tab-2" class="tab-pane" :class="{ active: tab == 2, show: tab == 2 }">
										<div class="p-4 b-b _600 nav-title">Settings</div>
										<form role="form" class="p-4 col-sm-6">
											<div class="form-group">
												<label>More Settings Here</label>
												<input type="text" class="form-control" v-model="profile.more" />
											</div>
										</form>
									</div>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveProfile"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="Profile"
								:objectName="full_name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";

import UserService from "@/services/UserService";
import TenantService from "@/services/TenantService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import DistrictService from "@/services/DistrictService";
import ValidationService from "@/services/ValidationService";
import notie from "@/services/NotieService";
import Utils from "@/services/Utils";
import BB from "bluebird";

export default {
	name: "Profile",

	props: ["user", "params", "query"],

	components: { EditPane, SaveOptionalModal },

	data() {
		return {
			tab: 1,
			mut_user: null,
			profile: {
				password: ""
			},
			roles: [],
			sRole: null,
			areas: [],
			sAreas: null,
			grades: [],
			sGrades: null,
			districts: [],
			sDistrict: null,
			password2: "",
			dirty: false,
			loading: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	created() {
		this.mut_user = _.cloneDeep(this.user);
		this.loadData();
		this.initValidation();

		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},

	watch: {
		sAreaIDs(newVal) {
			let oldVal = this.profile.content_area_ids;
			let same = true;
			if (newVal.length == oldVal.length) {
				for (let i = 0; i < newVal.length; i++) {
					if (newVal[i] != oldVal[i]) {
						console.log("ca", newVal[i], "not equal", oldVal[i]);
						same = false;
					}
				}
			} else {
				same = false;
			}

			if (!same) {
				this.profile.content_area_ids = newVal;
			}
		},
		sGradeIDs(newVal) {
			let oldVal = this.profile.grade_ids;
			let same = true;
			if (newVal.length == oldVal.length) {
				for (let i = 0; i < newVal.length; i++) {
					if (newVal[i] != oldVal[i]) {
						console.log("grade", newVal[i], "not equal", oldVal[i]);
						same = false;
					}
				}
			} else {
				same = false;
			}

			if (!same) {
				this.profile.grade_ids = newVal;
			}
		}
	},

	computed: {
		full_name() {
			if (this.profile.first_name && this.profile.first_name != "") {
				if (this.profile.last_name && this.profile.last_name != "") {
					return `${this.profile.first_name} ${this.profile.last_name}`;
				} else {
					return this.profile.first_name;
				}
			} else if (this.profile.last_name && this.profile.last_name != "") {
				return this.profile.last_name;
			} else {
				return "____";
			}
		},
		sAreaIDs() {
			return _.map(this.sAreas, "id");
		},
		sGradeIDs() {
			return _.map(this.sGrades, "id");
		}
	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a first or last name",
					func: () => {
						return (
							this.profile &&
							((this.profile.first_name && this.profile.first_name != "") ||
								(this.profile.last_name && this.profile.last_name != ""))
						);
					}
				},
				email: {
					group: "details",
					errorMsg: "You must assign a valid email address",
					func: () => {
						return this.profile && this.profile.email && this.profile.email.match(/.+\@.+\..+/);
					}
				},
				password: {
					group: "details",
					errorMsg: "Your password must be at least 5 characters long",
					func: () => {
						return (
							this.profile &&
							(!this.profile.password || this.profile.password == "" || this.profile.password.length >= 5)
						);
					}
				},
				passwordMatch: {
					group: "details",
					errorMsg: "Your passwords must match",
					func: () => {
						return (
							this.profile &&
							(!this.profile.password ||
								this.profile.password == "" ||
								this.profile.password == this.password2)
						);
					}
				}
			});
		},

		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"profile",
				(newc, old) => {
					console.log(Utils.diff(newc, old));
					this.dirty = true;
				},
				{ deep: true }
			);
		},

		loadData() {
			return BB.props({
				client: TenantService.getClient("current"),
				contentAreas: ContentAreaService.listContentAreas(),
				grades: GradeService.listGrades(),
				districts: DistrictService.listDistricts()
			})
				.then(resps => {
					this.dirty = false;
					this.profile = _.cloneDeep(this.mut_user);
					this.$set(this.profile, "password", "");
					this.password2 = "";

					this.roles = resps.client.data.roles;
					if (this.roles.length > 0 && this.profile) {
						if (this.profile.role) {
							this.sRole = _.find(this.roles, {
								id: this.profile.role.id
							});
						} else {
							this.sRole = null;
						}
					}

					this.sAreas = [];
					this.areas = resps.contentAreas.data.content_areas;
					if (this.areas && this.areas.length > 0 && this.profile) {
						_.each(this.profile.content_area_ids, caid => {
							let area = _.find(this.areas, {
								id: caid
							});
							if (area) {
								this.sAreas.push(area);
							}
						});
					}

					this.sGrades = [];
					this.grades = resps.grades.data;
					if (this.grades && this.grades.length > 0 && this.profile) {
						_.each(this.profile.grade_ids, gid => {
							let grade = _.find(this.grades, {
								id: gid
							});
							if (grade) {
								this.sGrades.push(grade);
							}
						});
					}

					this.districts = resps.districts.data.districts;
					if (this.districts && this.districts.length > 0 && this.profile) {
						if (this.profile.district_id) {
							this.sDistrict = _.find(this.districts, {
								id: this.profile.district_id
							});
						} else {
							this.sDistrict = null;
						}
					}

					this.watchChanges();
				})
				.catch(err => {
					console.log(err);
					notie.error("Error loading user", err);
				});
		},

		saveProfile() {
			return UserService.updateProfile(this.profile)
				.then(resp => {
					notie.info("Profile Updated");
					this.mut_user = this.profile;
					this.loadData();
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to update profile", err);
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/Profile/Profile.vue